/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../mutations/collections.generated";
import {
  UserPermissionFragmentDoc,
  GroupPermissionFragmentDoc,
} from "../../mutations/permissions.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PotentialCollectionFragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly name: string;
  readonly emoji: string | null;
  readonly canManage: boolean;
  readonly description: string | null;
  readonly collectionGrants: ReadonlyArray<{
    readonly __typename: "CollectionGrant";
    readonly id: c.CollectionGrantId;
    readonly role: Types.CollectionRole;
    readonly holder:
      | {
          readonly __typename: "Group";
          readonly groupId: c.GroupId;
          readonly groupName: string;
        }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        }
      | {
          readonly __typename: "User";
          readonly name: string | null;
          readonly email: string;
          readonly active: boolean;
          readonly imageUrl: string | null;
          readonly orgRole: Types.OrgRole;
          readonly userId: c.UserId;
        };
  }>;
};

export type ShareProjectGrantsAndCollectionsQueryVariables = Types.Exact<{
  searchString: Types.Scalars["String"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
  includeCollectionsInResults: Types.Scalars["Boolean"]["input"];
}>;

export type ShareProjectGrantsAndCollectionsQuery = {
  readonly __typename: "Query";
  readonly searchOrgUsers: ReadonlyArray<{
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
    readonly active: boolean;
    readonly imageUrl: string | null;
    readonly orgRole: Types.OrgRole;
  }>;
  readonly searchOrgGroups: ReadonlyArray<{
    readonly __typename: "Group";
    readonly id: c.GroupId;
    readonly groupName: string;
  }>;
  readonly collections?: {
    readonly __typename: "CollectionsConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CollectionsEdge";
      readonly node: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
        readonly name: string;
        readonly emoji: string | null;
        readonly canManage: boolean;
        readonly description: string | null;
        readonly collectionGrants: ReadonlyArray<{
          readonly __typename: "CollectionGrant";
          readonly id: c.CollectionGrantId;
          readonly role: Types.CollectionRole;
          readonly holder:
            | {
                readonly __typename: "Group";
                readonly groupId: c.GroupId;
                readonly groupName: string;
              }
            | {
                readonly __typename: "IntrinsicGroup";
                readonly intrinsicGroupId: Types.IntrinsicGroupId;
              }
            | {
                readonly __typename: "User";
                readonly name: string | null;
                readonly email: string;
                readonly active: boolean;
                readonly imageUrl: string | null;
                readonly orgRole: Types.OrgRole;
                readonly userId: c.UserId;
              };
        }>;
      };
    }>;
  };
};

export const PotentialCollectionFragmentDoc = /*#__PURE__*/ gql`
  fragment PotentialCollectionFragment on Collection {
    id
    name
    emoji
    canManage
    description
    collectionGrants {
      id
      ...CollectionGrantFragment
    }
  }
  ${CollectionGrantFragmentDoc}
`;
export const ShareProjectGrantsAndCollectionsDocument = /*#__PURE__*/ gql`
  query ShareProjectGrantsAndCollections(
    $searchString: String!
    $orgId: OrgId!
    $includeCollectionsInResults: Boolean!
  ) {
    searchOrgUsers(orgId: $orgId, searchString: $searchString, pageSize: 10) {
      id
      ...UserPermissionFragment
    }
    searchOrgGroups(orgId: $orgId, searchString: $searchString, pageSize: 10) {
      id
      ...GroupPermissionFragment
    }
    collections(
      after: null
      before: null
      first: 10
      last: null
      ownershipLevel: ALL
      searchTerm: $searchString
    ) @include(if: $includeCollectionsInResults) {
      edges {
        node {
          id
          ...PotentialCollectionFragment
        }
      }
    }
  }
  ${UserPermissionFragmentDoc}
  ${GroupPermissionFragmentDoc}
  ${PotentialCollectionFragmentDoc}
`;

/**
 * __useShareProjectGrantsAndCollectionsQuery__
 *
 * To run a query within a React component, call `useShareProjectGrantsAndCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareProjectGrantsAndCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareProjectGrantsAndCollectionsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      orgId: // value for 'orgId'
 *      includeCollectionsInResults: // value for 'includeCollectionsInResults'
 *   },
 * });
 */
export function useShareProjectGrantsAndCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  > &
    (
      | {
          variables: ShareProjectGrantsAndCollectionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  >(ShareProjectGrantsAndCollectionsDocument, options);
}
export function useShareProjectGrantsAndCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  >(ShareProjectGrantsAndCollectionsDocument, options);
}
export function useShareProjectGrantsAndCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShareProjectGrantsAndCollectionsQuery,
    ShareProjectGrantsAndCollectionsQueryVariables
  >(ShareProjectGrantsAndCollectionsDocument, options);
}
export type ShareProjectGrantsAndCollectionsQueryHookResult = ReturnType<
  typeof useShareProjectGrantsAndCollectionsQuery
>;
export type ShareProjectGrantsAndCollectionsLazyQueryHookResult = ReturnType<
  typeof useShareProjectGrantsAndCollectionsLazyQuery
>;
export type ShareProjectGrantsAndCollectionsSuspenseQueryHookResult =
  ReturnType<typeof useShareProjectGrantsAndCollectionsSuspenseQuery>;
export type ShareProjectGrantsAndCollectionsQueryResult = Apollo.QueryResult<
  ShareProjectGrantsAndCollectionsQuery,
  ShareProjectGrantsAndCollectionsQueryVariables
>;
